import React, { useEffect, useState, useRef } from 'react';
import Hls from 'hls.js';
import { Zap, Lock, Check, ShieldCheck, Play, Flame } from 'lucide-react';
import { Button } from '../ui/Shared';
const VIDEO_SRC = 'https://vz-59c3ae15-de5.b-cdn.net/56e02587-7c6c-4254-acec-f4be260d16e2/playlist.m3u8';
export function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const handlePlay = () => {
    const video = videoRef.current;
    if (!video) return;
    if (Hls.isSupported()) {
      const hls = new Hls();
      hls.loadSource(VIDEO_SRC);
      hls.attachMedia(video);
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play();
        setIsPlaying(true);
      });
    } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = VIDEO_SRC;
      video.addEventListener('loadedmetadata', () => {
        video.play();
        setIsPlaying(true);
      });
    }
  };
  return <section id="hero" className="relative pt-20 pb-16 overflow-hidden bg-[radial-gradient(ellipse_at_top,#1A2340_0%,#0A0F1E_60%)]" data-id="element-228">
      {/* Background overlay */}
      <div className="absolute inset-0 opacity-[0.04] bg-center bg-cover" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1543362906-acfc16c67564?w=800&q=60')"
    }} data-id="element-229" />

      <div className="max-w-[780px] mx-auto px-6 text-center relative z-10" data-id="element-230">
        <p className="text-xs font-bold tracking-[3px] uppercase text-accent mb-4" data-id="element-231">
          Rutina digestiva directa y fácil de aplicar
        </p>

        <h1 className="font-playfair text-[26px] sm:text-4xl md:text-5xl lg:text-[58px] font-black leading-[1.12] mb-8" data-id="element-232">
          Reflujo Cero en 72h
          <br data-id="element-233" />
          <span className="text-gradient-gold" data-id="element-234">
            Reduce el ardor, la subida de ácido y la presión en el pecho en 3
            días
          </span>
          <br data-id="element-235" />
          <span className="text-text-muted text-[0.55em] font-bold leading-[1.3]" data-id="element-236">
            Sin vivir a punta de omeprazol, sin comer como preso, sin pasar
            noches sentado.
            <br className="hidden md:inline" data-id="element-237" /> Solo un protocolo casero de
            ajuste digestivo — incluso si llevas años con acidez.
          </span>
        </h1>

        <div className="text-base md:text-lg text-text-muted max-w-[680px] mx-auto mb-9 leading-relaxed text-left bg-surface-2/50 p-6 rounded-xl border border-white/5" data-id="element-238">
          <p className="mb-4" data-id="element-239">
            Son las 11:30 de la noche. Te acabas de acostar y, de repente, esa
            ola de fuego sube por tu pecho. Sientes un nudo en la garganta, un
            sabor amargo y una quemazón que no te deja cerrar los ojos.
          </p>
          <p data-id="element-240">
            Te sientas en la cama, frustrado, sabiendo que mañana estarás
            agotado. Has probado de todo, pero el alivio dura apenas unos
            minutos antes de que el ácido regrese con más fuerza.
          </p>
        </div>

        <div className="mt-12 max-w-[720px] mx-auto rounded-xl overflow-hidden border border-accent/20 shadow-[0_30px_80px_rgba(0,0,0,0.6)] relative" data-id="element-241">
          <div className="relative bg-surface-2 aspect-video" data-id="element-242">
            <video ref={videoRef} className="w-full h-full object-cover" controls={isPlaying} playsInline preload="none" data-id="element-243" />
            {!isPlaying && <button onClick={handlePlay} className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-surface-2 cursor-pointer border-none group" data-id="element-244">
                <div className="w-20 h-20 bg-gradient-gold rounded-full flex items-center justify-center transition-transform duration-300 group-hover:scale-110" data-id="element-245">
                  <Play className="w-8 h-8 text-primary ml-1 fill-current" data-id="element-246" />
                </div>
                <p className="text-text-muted text-sm" data-id="element-247">
                  Mira por qué esto es diferente a todo lo que has probado
                </p>
              </button>}
          </div>
        </div>
      </div>
    </section>;
}